import { StateSlice } from '../../../../subject/testRunner/graph-state/state-holder';

export const IATStimulusSlice = new StateSlice('stimulus-state', () => ({
  fail: false,
}));
